module.exports = __webpack_public_path__ + "img/HPS018NG.bcf16086.png";